var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "testimonial-section",
    style: _vm.styles
  }, [_c('div', {
    staticClass: "testimonials-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.header))])]), _vm._v(" "), _c('div', {
    ref: "swiper",
    staticClass: "swiper testimonials"
  }, [_c('div', {
    staticClass: "swiper-wrapper testimonial-wrapper",
    style: !_vm.activateSwipe && {
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  }, _vm._l(_vm.testimonials, function (testimonial) {
    return _c('div', {
      key: testimonial._key,
      staticClass: "swiper-slide testimonial-card",
      style: _vm.testimonialsStyles
    }, [_c('div', {
      staticClass: "testimonial-header"
    }, [_c('div', {
      staticClass: "testimonial-name"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(testimonial.name) + "\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "testimonial-date"
    }, [_vm._v("– " + _vm._s(testimonial.date))])])]), _vm._v(" "), _c('div', {
      staticClass: "testimonial-stars"
    }, _vm._l(testimonial.rating, function (star, index) {
      return _c('div', {
        key: index,
        staticClass: "star"
      }, [_c('svg', {
        attrs: {
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "25",
          "height": "24",
          "viewBox": "0 0 25 24",
          "fill": "none"
        }
      }, [_c('path', {
        attrs: {
          "d": "M12.0703 0.948628C12.2696 0.335283 13.1373 0.335285 13.3366 0.94863L15.6794 8.15912C15.7685 8.43342 16.0241 8.61913 16.3125 8.61913H23.8941C24.539 8.61913 24.8072 9.44438 24.2854 9.82345L18.1518 14.2798C17.9185 14.4493 17.8208 14.7498 17.91 15.0241L20.2528 22.2346C20.4521 22.8479 19.7501 23.358 19.2283 22.9789L13.0947 18.5226C12.8614 18.353 12.5454 18.353 12.3121 18.5226L6.17849 22.9789C5.65675 23.358 4.95475 22.8479 5.15404 22.2346L7.49687 15.0241C7.58599 14.7498 7.48836 14.4493 7.25503 14.2798L1.12141 9.82345C0.599669 9.44438 0.867811 8.61913 1.51272 8.61913H9.09428C9.3827 8.61913 9.63831 8.43342 9.72743 8.15912L12.0703 0.948628Z",
          "fill": _vm.starFill
        }
      })])]);
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "testimonial-title"
    }, [_vm._v(_vm._s(testimonial.title))]), _vm._v(" "), _c('blockquote', {
      staticClass: "testimonial-quote"
    }, [!_vm.readMore[testimonial._key] ? _c('p', [_vm._v("\n\t\t\t\t\t\t\"" + _vm._s(testimonial.quote.substring(0, 200) + '...') + "\n\t\t\t\t\t")]) : _vm.readMore[testimonial._key] ? _c('p', [_vm._v("\"" + _vm._s(testimonial.quote) + "\"")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "testimonial-card-read-more"
    }, [!_vm.readMore[testimonial._key] ? _c('div', {
      staticClass: "testimonial-card-read-more-text",
      on: {
        "click": function ($event) {
          return _vm.showMore(testimonial._key);
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tRead more\n\t\t\t\t\t")]) : _vm.readMore[testimonial._key] ? _c('div', {
      staticClass: "testimonial-card-read-more-text",
      on: {
        "click": function ($event) {
          return _vm.showLess(testimonial._key);
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tRead less\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "testimonial-source",
      attrs: {
        "href": testimonial.sourceLink,
        "target": "_blank"
      }
    }, [_vm._v("Source: " + _vm._s(testimonial.sourceText))])]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };